import React from 'react';
import logo from '../assets/logo.png';  // Import your logo

const StepIndicator = ({ step }) => (
  <div className="relative px-6 py-4 border-b border-gray-200">
    {/* Logo at the top left */}
    <div className="absolute top-0 right-0 p-2">
      <img src={logo} alt="Logo" className="h-12" /> {/* Adjust the size as needed */}
    </div>

    {/* Title and Step Indicators */}
    <div className="ml-1"> {/* Added left margin to offset the logo */}
      <h1 className="text-2xl font-semibold text-purple-600">Investor Subscription Application Form</h1>
      <div className="mt-4 flex items-center justify-between">
        <div className="w-full flex items-center">
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${step >= 1 ? 'bg-purple-600 text-white' : 'bg-gray-200'}`}>1</div>
          <div className={`flex-1 h-1 mx-4 ${step >= 2 ? 'bg-purple-600' : 'bg-gray-200'}`} />
          <div className={`w-10 h-10 rounded-full flex items-center justify-center ${step >= 2 ? 'bg-purple-600 text-white' : 'bg-gray-200'}`}>2</div>
        </div>
      </div>
    </div>
  </div>
);

export default StepIndicator;
